<template>
  <div class="w-100 my-2 p-2 border">
    <section class="w-100">
      <h5 class="text-center">網站設定</h5>
    </section>

    <section class="text-left my-2">
      <button class="btn-outline-primary btn-sm btn mr-2" @click="createBlock()">
        新增區塊
      </button>

      <button class="btn-outline-primary btn-sm btn mr-2" @click="gotoPage('webManage', true)">
        調整資料
      </button>

      <button class="btn-outline-primary btn-sm btn mr-2" @click="timerSetting(true)">
        計時器設定
      </button>

      <button class="btn-outline-primary btn-sm btn" @click="hotSearchSetting(true)">
        熱門設定
      </button>
    </section>

    <section class="d-flex align-items-center border p-2"
      v-for="(block, key) in orderBy(filterDelete(blockList))" :key="'block__' + key">

      <div class="d-flex flex-column" style="min-width: 80px">
        <!-- ctrl bar -->
        <button class="btn-outline-primary btn-sm btn mb-2" v-if="key > 0" @click="upChange(key)">
          <font-awesome-icon class='cur-print' :icon="['fas', 'arrow-circle-up']" />
        </button>

        <button class="btn-outline-primary btn-sm btn mb-2"
          v-if="key != filterDelete(blockList).length - 1" @click="downChange(key)">
          <font-awesome-icon class='cur-print' :icon="['fas', 'arrow-circle-down']" />
        </button>

        <button class="btn-outline-primary btn-sm btn mb-2"
          @click="openManagement(block.model, block)">
          管理
        </button>

        <button class="btn-outline-danger btn-sm btn" @click="deleteBlock(block)">
          刪除
        </button>
      </div>
      <div class="flex-fill px-2">
        <!-- view -->
        <div class="w-100" v-if="(block.model == 'slide')">
          <div class="w-100 position-relative">
            <!-- slider -->
            <b-carousel :interval="4000" :controls="true" :indicators="true" img-width="800"
              img-height="400" style="text-shadow: 1px 1px 2px #333;">
              <b-carousel-slide :caption="data.name" img-blank :img-alt="data.name"
                :background="data.backColor" v-for="(data, index) in block.dataList"
                :key="'banner__'+key+'__'+index">
              </b-carousel-slide>
            </b-carousel>

            <div class="position-absolute timer-block" style="top:0" v-if="block.slide.timer.show">
              <div class="h-100 d-flex align-items-center justify-content-center">
                倒數計時器
              </div>
            </div>

            <div class="w-100 position-absolute" style="bottom: 0; z-index: 999"
              v-if="block.slide.hotSearch.show">
              <div class="h-100 d-flex align-items-center justify-content-center p-2">
                <div class="d-flex">
                  <span class="text-danger pr-1">●</span>
                  <span class="text-white letter-s-2">{{block.title.name}}</span>
                  <b class="text-white">{{block.title.bName}}</b>
                </div>
                <div class="d-flex align-items-center justify-content-end flex-fill">
                  <div class="bg-white border ml-2 p-2" v-for="i in 4"
                    :key="'hot__search__'+ key + '__' + i">
                    <div class="d-flex align-items-center justify-content-center">
                      <div class="mr-1">熱門{{i}}</div>
                      <font-awesome-icon :icon="['far', 'play-circle']" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-100" v-if="block.model == 'hotkey'">
          <div class="w-100 d-flex justify-content-end">
            <!-- hotkey -->

            <div class="d-flex hotkey__box">
              <div class="d-flex align-items-center hotkey__item px-2"
                v-for="(hot, index) in block.dataList" :key="'hotkey__' + key + '__' + index">
                <div class="d-flex align-items-center justify-content-center mr-1">
                  <font-awesome-icon :icon="['fas', hot.icon]" />
                </div>
                <span class="hotkey__name">{{hot.name}}<span
                    class="hotkey__ename">{{hot.smallName}}</span></span>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 multi__box" v-if="block.model == 'multiProduct'">
          <!-- product multi -->
          <div class="d-flex pl-2">
            <!-- title -->
            <span class="text-danger pr-1">●</span>
            <span class="text-left letter-s-2 pb-2 border-bottom border-danger"
              style="min-width: 60px">{{block.title.name}}</span>
            <b class="text-left flex-fill pb-2 border-bottom">{{block.title.bName}}</b>
            <a class="link__tag pb-2 border-bottom text-dark"
              :href="block.title.linkUrl">{{block.title.linkName}}</a>
          </div>

          <div class="w-100 product__outside__box position-relative mt-2">
            <div class="position-absolute left d-flex align-items-center">
              <div class="left__btn d-flex">
                <font-awesome-icon :icon="['fas', 'chevron-left']" class="text-white" />
              </div>
            </div>

            <div class="position-absolute right d-flex align-items-center">
              <div class="right__btn d-flex">
                <font-awesome-icon :icon="['fas', 'chevron-right']" class="text-white" />
              </div>
            </div>

            <div class="product__inside__box d-flex align-items-center overflow-auto"
              v-if="block.multiProduct.subModel == 'fixed'">
              <!-- 固定寬度 -->
              <div class="product__fixed__item" v-for="(product, index) in block.dataList"
                :key="'product__'+key+'__'+index">
                <div class="h-100 d-flex align-items-center">
                  <div class="d-flex align-items-center justify-content-center bg-light"
                    style="width:160px; min-width: 160px; height: 80%">
                    <span>Image1</span>
                  </div>
                  <div
                    class="h-100 flex-fill d-flex flex-column align-content-center align-self-start py-4">
                    <h4>{{product.name}}</h4>
                    <div class="h-100 p-2 text-wrap">
                      <div class="text-left" v-html="product.content"></div>
                    </div>
                    <div class="text-right letter-s-1">
                      <a herf="#"
                        class="btn btn-sm btn-success text-white">{{block.multiProduct.submitName}}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-100 product__inside__box d-flex  align-items-center overflow-auto"
              v-if="block.multiProduct.subModel == 'float'">
              <!-- 浮動寬度 -->
              <div class="product__float__item" v-for="(product, index) in block.dataList"
                :key="'multiProduct__'+key+'__'+index">
                <div class="h-100 d-flex flex-column align-items-center py-4">
                  <h4>{{product.name}}</h4>
                  <div
                    class="w-100 h-100 flex-fill d-inline-flex align-content-center align-self-start py-4 px-2">
                    <div class="d-flex align-items-center justify-content-center bg-light"
                      style="width:80; min-width: 80px; height: 80px">
                      <span>Image1</span>
                    </div>
                    <div class="h-100 d-inline-flex flex-fill p-2 text-wrap">
                      <span class="text-left">{{product.content}}</span>
                    </div>
                  </div>
                  <div class="w-100 text-right letter-s-1">
                    <a herf="#"
                      class="btn btn-sm btn-success text-white">{{block.multiProduct.submitName}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-100 multi__box" v-if="block.model == 'singleProduct'">
          <!-- product single  -->
          <div class="w-100 mt-2" v-if="block.singleProduct.subModel == 'leftContentRightImage'">
            <!-- 左文字、右圖片 -->
            <div class="row no-gutters" v-for="(product,index) in getFirst(block.dataList)"
              :key="'singleProduct__'+key+'__'+index">
              <div class="col-md-6">
                <div class="d-flex flex-fill">
                  <span class="text-danger pr-1">●</span>
                  <span class="text-left letter-s-2 pb-2 border-bottom border-danger"
                    style="min-width: 60px">{{block.title.name}}</span>
                  <b class="text-left flex-fill pb-2 border-bottom">{{block.title.bName}}</b>
                </div>
                <div class="w-100 h-100 d-inline-flex py-4">
                  <div class="h-100 bg-light d-flex align-items-center justify-content-center"
                    style="width: 140px">
                    <span>Image</span>
                  </div>
                  <div class="flex-fill px-2">
                    <h4>{{product.name}}</h4>
                    <div class="w-100 text-left" v-html="product.content"></div>
                    <div class="d-flex justify-content-end">
                      <a herf="#"
                        class="btn btn-sm btn-success text-white">{{block.singleProduct.submitName}}</a>
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-md-6">
                <div class="d-flex flex-fill justify-content-start">
                  <a class="link__tag pb-2 text-dark"
                    :href="block.title.linkUrl">{{block.title.linkName}}</a>
                </div>
                <div class="d-flex flex-fill align-items-center justify-content-center">
                  <a :href="product.btnUrl">
                    <b-img class="w-100" :src="product.btnImage"></b-img>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-100" v-if="block.model == 'list'">
          <div class="d-flex pl-2">
            <!-- title -->
            <span class="text-danger pr-1">●</span>
            <span class="text-left letter-s-2 pb-2 border-bottom border-danger"
              style="min-width: 60px">{{block.title.name}}</span>
            <b class="text-left flex-fill pb-2 border-bottom">{{block.title.bName}}</b>
            <a class="link__tag pb-2 border-bottom text-dark"
              :href="block.title.linkUrl">{{block.title.linkName}}</a>
          </div>
          <div class="list__box p-2">
            <div class="d-flex flex-column list__box__item border-bottom p-2 mb-2" v-for="(list, index) in block.dataList"
              :key="'list__'+key+'__'+index">
              <h4 class="d-flex flex-fill justify-content-start text-wrap ">{{list.name}}</h4>
              <div class="d-flex flex-fill text-left justify-content-start text-wrap" v-html="list.content"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column" style="min-width: 200px; max-width: 200px">
        <!-- select bar -->
        <div class="d-flex align-items-center">
          <div style="min-width: 80px">選擇模式：</div>
          <div class="flex-fill">
            <select class="form-control" v-model="block.model">
              <option value="" selected>請選擇</option>
              <option :value="model.values" v-for="(model,index) in blockModel"
                :key="'model__type__' + key + '__' + index">
                {{model.name}}
              </option>
              <!-- 
              <option>快捷鍵模式</option>
              <option>多產品模式</option>
              <option>單產品模式</option>
              <option>清單模式</option> 
              -->
            </select>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <!-- ctrl bar -->
          <div class="w-100 h-100 mt-2 pt-2 border-top" v-if="(block.model == 'slide')">
            <!-- slider -->
            <div class="d-flex align-items-center mb-2">
              <span class="text-right" style="min-width: 80px">計時器：</span>
              <input type="checkbox" v-model="block.slide.timer.show">
            </div>

            <div class="d-flex align-items-center mb-2">
              <span class="text-right" style="min-width: 80px">熱門搜尋：</span>
              <input type="checkbox" v-model="block.slide.hotSearch.show">
            </div>

            <div class="w-100 mt-2 pt-2 border-top" v-if="block.slide.hotSearch.show">
              <!-- hot search -->
              <div class="d-flex align-items-center mb-2">
                <span class="text-right" style="min-width: 80px">主標題：</span>
                <input type="text" class="form-control flex-fill" placeholder="熱門搜尋"
                  v-model="block.title.name">
              </div>

              <div class="d-flex align-items-center mb-2">
                <span class="text-right" style="min-width: 80px">次標題：</span>
                <input type="text" class="form-control flex-fill" placeholder="NEWS"
                  v-model="block.title.bName">
              </div>
            </div>
          </div>

          <div class="w-100 h-100 mt-2 pt-2 border-top" v-if="(block.model == 'multiProduct')">
            <!-- product multi -->
            <div class="d-flex align-items-center mb-2">
              <span class="text-right" style="min-width: 80px">主標題：</span>
              <input type="text" class="form-control flex-fill" placeholder="多樣產品"
                v-model="block.title.name">
            </div>

            <div class="d-flex align-items-center mb-2">
              <span class="text-right" style="min-width: 80px">次標題：</span>
              <input type="text" class="form-control flex-fill" placeholder="Multi"
                v-model="block.title.bName">
            </div>

            <div class="d-flex flex-column align-items-center mb-2">
              <div class="d-flex align-items-center mb-2">
                <span class="text-right" style="min-width: 80px">連結：</span>
                <input type="text" class="form-control flex-fill" placeholder="連結名稱"
                  v-model="block.title.linkName">
              </div>
              <input type="text" class="form-control flex-fill" placeholder="Url Link"
                v-model="block.title.linkUrl">
            </div>

            <div class="w-100 mt-2 pt-2 border-top">
              <div class="w-100">
                <div class="d-flex align-items-center mb-2">
                  <span class="text-right" style="min-width: 80px">選擇樣式：</span>
                  <select class="form-control" v-model="block.multiProduct.model">
                    <option value="" selected>請選擇</option>
                    <option v-for="(model, index) in multiProductModel"
                      :key="'multi__model__'+ key + '__' + index" :value="model.values">
                      {{model.name}}</option>
                  </select>
                </div>
                <select class="form-control mb-2" v-model="block.multiProduct.subModel"
                  v-if="checkSubModel(block.multiProduct.model, multiProductModel)">
                  <option value="" selected>請選擇</option>
                  <option
                    v-for="(subModel, index) in getSubModel(block.multiProduct.model, multiProductModel)"
                    :key="'multi__subModel__'+ key + '__' + index" :value="subModel.values">
                    {{subModel.name}}</option>
                </select>
                <div class="d-flex align-items-center mb-2">
                  <span class="text-right" style="min-width: 80px">按鈕名稱：</span>
                  <input type="text" class="form-control flex-fill" placeholder="按鈕名稱"
                    v-model="block.multiProduct.submitName">
                </div>
              </div>
            </div>

          </div>

          <div class="w-100 h-100 mt-2 pt-2 border-top" v-if="(block.model == 'singleProduct')">
            <!-- product single -->
            <div class="d-flex align-items-center mb-2">
              <span class="text-right" style="min-width: 80px">主標題：</span>
              <input type="text" class="form-control flex-fill" placeholder="單一產品"
                v-model="block.title.name">
            </div>

            <div class="d-flex align-items-center mb-2">
              <span class="text-right" style="min-width: 80px">次標題：</span>
              <input type="text" class="form-control flex-fill" placeholder="Single"
                v-model="block.title.bName">
            </div>

            <div class="d-flex flex-column align-items-center mb-2">
              <div class="d-flex align-items-center mb-2">
                <span class="text-right" style="min-width: 80px">連結：</span>
                <input type="text" class="form-control flex-fill" placeholder="連結名稱"
                  v-model="block.title.linkName">
              </div>
              <input type="text" class="form-control flex-fill" placeholder="Url Link"
                v-model="block.title.linkUrl">
            </div>

            <div class="d-flex align-items-center mb-2">
              <span class="text-right" style="min-width: 80px">背景底圖：</span>
              <input type="text" class="form-control flex-fill" placeholder="背景底圖"
                v-model="block.title.backImage">
            </div>

            <div class="w-100 mt-2 pt-2 border-top">
              <div class="w-100">
                <div class="d-flex align-items-center mb-2">
                  <span class="text-right" style="min-width: 80px">選擇樣式：</span>
                  <select class="form-control" v-model="block.singleProduct.model">
                    <option value="" selected>請選擇</option>
                    <option v-for="(model, index) in singleProductModel"
                      :key="'multi__model__'+ key + '__' + index" :value="model.values">
                      {{model.name}}</option>
                  </select>
                </div>
                <select class="form-control mb-2" v-model="block.singleProduct.subModel"
                  v-if="checkSubModel(block.singleProduct.model, singleProductModel)">
                  <option value="" selected>請選擇</option>
                  <option
                    v-for="(subModel, index) in getSubModel(block.singleProduct.model, singleProductModel)"
                    :key="'multi__subModel__'+ key + '__' + index" :value="subModel.values">
                    {{subModel.name}}</option>
                </select>
                <div class="d-flex align-items-center mb-2">
                  <span class="text-right" style="min-width: 80px">按鈕名稱：</span>
                  <input type="text" class="form-control flex-fill" placeholder="按鈕名稱"
                    v-model="block.singleProduct.submitName">
                </div>
              </div>
            </div>
          </div>

          <div class="w-100 h-100 mt-2 pt-2 border-top" v-if="(block.model == 'list')">
            <!-- list -->
            <div class="d-flex align-items-center mb-2">
              <span class="text-right" style="min-width: 80px">主標題：</span>
              <input type="text" class="form-control flex-fill" placeholder="清單標題"
                v-model="block.title.name">
            </div>

            <div class="d-flex align-items-center mb-2">
              <span class="text-right" style="min-width: 80px">次標題：</span>
              <input type="text" class="form-control flex-fill" placeholder="List"
                v-model="block.title.bName">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="pt-2 d-flex justify-content-end">
      <button class="btn btn-primary btn-sm text-white ml-2">修改</button>
      <button class="btn btn-success btn-sm text-white ml-2" @click="saveWebSetting()">儲存</button>
      <button class="btn btn-danger btn-sm text-white ml-2">取消</button>
    </section>

    <b-modal v-model="manage.open" size="lg">
      <template #modal-header>
        <h4>管理{{getModelName(manage.model)}}</h4>
      </template>

      <template>
        <div>
          <div class="w-100">
            <div class="d-flex">
              <button class="btn btn-sm btn-outline-primary"
                @click="openInsertOrUpdate('insert', manage.model)">新增</button>
            </div>
            <div class="d-flex mt-2 overflow-auto">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <td></td>
                    <td v-for="(field, key) in getField()" :key="'field__'+key">
                      {{field["name"]}}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, key) in manage.data" :key="'data__'+key">
                    <td>
                      <button class="btn btn-sm btn-outline-primary"
                        @click="openInsertOrUpdate('update', manage.model, data)">管理</button>
                    </td>
                    <td v-for="(field, key) in getField()" :key="'data__field__'+key">
                      {{data[field["field"]]}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>

      <template #modal-footer="{close}">
        <button class="btn btn-sm btn-outline-danger" @click="close()">關閉</button>
      </template>
    </b-modal>

    <b-modal v-model="manageTemp.open" @ok="manageSave()" @cancel="manageSave(false)">
      <template #modal-header>
        <h4>{{getModelName(manageTemp.model)}}-{{(manageTemp.method=="insert") ? "新增":"修改"}}</h4>
      </template>

      <template>
        <div>
          <div class="d-flex align-items-center" :class="{'mt-2': (index!=0)}"
            v-for="(field, index) in getField()" :key="'field__box__' + index"
            v-if="field['field'] != 'isonline'">
            <label class="px-2 text-nowrap" style="min-width: 80px">{{field.name}}</label>

            <b-input v-model="manageTemp.data[field['field']]" :type="field['type']"
              v-if="!(field['type'] == 'option')"></b-input>
            <select class="form-control" v-model="manageTemp.data[field['field']]"
              v-if="field['type']=='option'">
              <option value="">請選擇</option>
              <option :value="func.values" v-for="(func, index) in func" :key="'func__'+index">
                {{func.name}}</option>
            </select>
          </div>
          <!-- <div class="d-flex align-items-center">
            <label class="px-2 text-nowrap" style="min-width: 80px">主標題</label>
            <b-input v-model="manageTemp.data.name"></b-input>
          </div>

          <div class="d-flex align-items-center mt-2">
            <label class="px-2 text-nowrap" style="min-width: 80px">次標題</label>
            <b-input v-model="manageTemp.data.smallName"></b-input>
          </div>

          <div class="d-flex align-items-center mt-2">
            <label class="px-2 text-nowrap" style="min-width: 80px">圖示</label>
            <b-input v-model="manageTemp.data.icon"></b-input>
          </div>

          <div class="d-flex align-items-center mt-2">
            <label class="px-2 text-nowrap" style="min-width: 80px">標示</label>
            <b-input v-model="manageTemp.data.forText"></b-input>
          </div>

          <div class="d-flex align-items-center mt-2">
            <label class="px-2 text-nowrap" style="min-width: 80px">結束時間</label>
            <b-input v-model="manageTemp.data.endTime"></b-input>
          </div>

          <div class="d-flex align-items-center mt-2">
            <label class="px-2 text-nowrap" style="min-width: 80px">圖片</label>
            <b-input v-model="manageTemp.data.image"></b-input>
          </div>

          <div class="d-flex align-items-center mt-2">
            <label class="px-2 text-nowrap" style="min-width: 80px">連結網址</label>
            <b-input v-model="manageTemp.data.url"></b-input>
          </div>

          <div class="d-flex align-items-center mt-2">
            <label class="px-2 text-nowrap" style="min-width: 80px">內容說明</label>
            <b-input v-model="manageTemp.data.content"></b-input>
          </div>

          <div class="d-flex align-items-center mt-2">
            <label class="px-2 text-nowrap" style="min-width: 80px">分類</label>
            <b-input v-model="manageTemp.data.func"></b-input>
          </div>

          <div class="d-flex align-items-center mt-2">
            <label class="px-2 text-nowrap" style="min-width: 80px">背景顏色</label>
            <b-input v-model="manageTemp.data.backColor"></b-input>
          </div> -->
        </div>
      </template>

      <template #modal-footer="{ok, cancel, close}">
        <button class="btn btn-outline-success btn-sm" v-if="manageTemp.method == 'insert'"
          @click="cancel()">暫存不上架</button>

        <button class="btn btn-outline-danger btn-sm" v-if="manageTemp.method == 'update'"
          @click="deleteModelList()">刪除</button>

        <button class="btn btn-outline-success btn-sm"
          @click="ok()">{{manageTemp.method == "insert" ? "新增": "修改"}}</button>

        <button class="btn btn-outline-danger btn-sm" @click="close()">關閉</button>
      </template>
    </b-modal>

  </div>
</template>

<script>
  import ctrl from "@/js/webSetting/webSetting";
  export default ctrl;

</script>

<style lang="scss">
  @for $i from 0 through 5 {
    .letter-s-#{$i} {
      letter-spacing: 1px*$i;
    }
  }

  .timer-block {
    width: 180px;
    height: 80px;
    background-color: rgba(220, 181, 50, 0.7);
  }

  .hotkey__box {
    .hotkey__item {
      border-left: 1px solid black;

      .hotkey__name {
        .hotkey__ename {
          &:first-letter {
            font-weight: 900;
            font-size: 20px;
            line-height: 12px;
            margin-top: -1rem;
          }
        }
      }

      &:last-child {
        border-right: 1px solid black;
      }
    }
  }

  .multi__box {
    >.product__outside__box {
      height: 300px;

      >.left {
        left: 0;
        height: 100%;

        >.left__btn {
          background-color: grey;
          padding: 0.5rem;
        }
      }

      >.right {
        right: 0;
        height: 100%;

        >.right__btn {
          background-color: grey;
          padding: 0.5rem;
        }
      }

      >.product__inside__box {
        height: 100%;

        .product__fixed__item {
          width: calc(100% / 2);
          min-width: calc(100% / 2);
          height: 100%;
        }

        .product__float__item {
          height: 100%;
          min-width: 260px;
        }
      }
    }
  }

  .link__tag {
    font-size: 12px;

    &::before {
      content: "+";
    }
  }

</style>
